import { Component, ElementRef, OnInit, ViewChild, AfterViewChecked } from '@angular/core';
import { ProductService } from '../../../services/productservice';
import { Product } from '../../../services/product';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import * as _ from 'lodash';
import { DomSanitizer, SafeUrl, Title } from '@angular/platform-browser';
import { environment } from '@env/environment';
@Component({
  selector: 'app-high-lights-all',
  templateUrl: './high-lights-all.component.html',
  styleUrls: ['./high-lights-all.component.scss'],
  providers: [MessageService],
})
export class HighLightsAllComponent implements OnInit, AfterViewChecked {
  @ViewChild('productsList') productsList: ElementRef;
  highlightsProducts: Product[] = [];
  public pageNumber = 0;
  public isViewMoreRecords: boolean;
  public localStorageData: any;
  noOfPages: any;
  sortValue: any = 'newest';
  language: string;
  specialInterestItems: any;
  selectedSpecialInterest: any;
  resultsFound: any;
  images: any = [];
  blogBannerContent: any = { bannerImage: null, bannerTitle: null, content: null };
  activeIndex: any;
  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5,
    },
    {
      breakpoint: '768px',
      numVisible: 3,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];
  displayCustom: boolean;

  constructor(
    private route: ActivatedRoute,
    private productService: ProductService,
    private router: Router,
    private messageService: MessageService,
    protected sanitizer: DomSanitizer,
    private titleService: Title
  ) {
    const url = window.location.href;
    let prod = true;
    if (url.indexOf('localhost') >= 0 || url.indexOf('staging') >= 0) {
      prod = false;
    }
    this.specialInterestItems = [
      {
        name: 'Culture & History',
        value: '28',
        icon: 'icon-icons8-romance-50',
        selected: false,
      },
      {
        name: 'Things To Do',
        value: !prod ? '29' : '32',
        icon: 'icon-icons8-scuba-mask-50',
        selected: false,
      },
      {
        name: 'Sustainability',
        value: !prod ? '30' : '31',
        icon: 'icon-icons8-fishing-50',
        selected: false,
      },
      {
        name: 'Focus',
        value: !prod ? '31' : '29',
        icon: 'icon-icons8-sail-boat-50',
        selected: false,
      },
      {
        name: 'Nature & Wildlife',
        value: !prod ? '33' : '30',
        icon: 'icon-icons8-leaf-50',
        selected: false,
      },
      {
        name: 'Travel Tips',
        value: !prod ? '32' : '33',
        icon: 'icon-icons8-home-office-50',
        selected: false,
      },
      {
        name: 'Gastronomy',
        value: '51',
        icon: 'icon-gastronomy',
        selected: false,
      },
      {
        name: 'Local Made',
        value: '50',
        icon: 'icon-local-made',
        selected: false,
      },
    ];
  }
  selectedItem: string;
  suggestions: string[] = [];

  ngOnInit(): void {
    this.blogListingBanner();
    this.loadData();
  }

  onSelectBlogTitle(event: any) {
    this.highlightsProducts = [];
    let result = this.specialInterestFilter([event]);
    let val = result[0];
    let modifiedUri = this.modifyUri(val.uri);
    let modifiedResult = {
      ...val,
      uri: modifiedUri,
    };
    this.highlightsProducts.push(modifiedResult);
    this.isViewMoreRecords = false;
  }

  clear() {
    this.selectedItem = null;
    this.loadData();
  }

  searchHighlights(event: any) {
    this.productService.getSuggestions(event.query).subscribe((res: any) => {
      this.suggestions = res.results;
    });
  }

  //modifyURI function is for Replace image url
  modifyUri(originalUri: string): string {
    return originalUri.replace(environment.imageOldurl, environment.imageNewurl);
  }
  blogListingBanner() {
    this.productService.getBlogListing().subscribe((res) => {
      this.blogBannerContent = res;
      this.images.push(this.blogBannerContent.bannerImage);
      this.titleService.setTitle(this.blogBannerContent.bannerTitle + ' ' + '| The Seychelles Islands');
    });
  }

  // get popular items
  getPopularityData(pageNo?: any, selectedVals?: any) {
    let itemCode: any = [];
    if (selectedVals) {
      Array.from(selectedVals).map((data: any) => {
        itemCode.push(data);
      });
    } else {
      itemCode = '';
    }
    return this.productService.getPopularHilights(pageNo, this.language, itemCode).then((res) => {
      this.localStorageData = [];
      if (pageNo == 0) {
        this.highlightsProducts = [];
      }
      let result = this.specialInterestFilter(res.results);
      for (var i = 0; i < result.length; i++) {
        let modifiedUri = this.modifyUri(result[i].uri);
        let modifiedResult = {
          ...result[i], // Copy other properties from the original object
          uri: modifiedUri, // Replace the 'uri' property with the modified URI
        };
        this.highlightsProducts.push(modifiedResult);
        // this.highlightsProducts.push(res.results[i]);
      }

      localStorage.removeItem('data');
      localStorage.setItem('data', JSON.stringify(this.highlightsProducts));
      const newData: any = JSON.parse(localStorage.getItem('data'));
      this.localStorageData = newData;
      this.noOfPages = res.pager.pages;
      this.resultsFound = res.pager.count;
      this.isShowViewMore();
    });
  }
  getDataByAlphabet(pageNo?: any, selectedVals?: any) {
    let itemCode: any = [];
    if (selectedVals) {
      Array.from(selectedVals).map((data: any) => {
        itemCode.push(data);
      });
    } else {
      itemCode = '';
    }
    return this.productService.getBlogsByAlphabet(pageNo, this.language, this.sortValue, itemCode).then((res) => {
      this.localStorageData = [];
      if (pageNo == 0) {
        this.highlightsProducts = [];
      }
      let result = this.specialInterestFilter(res.results);
      for (var i = 0; i < result.length; i++) {
        let modifiedUri = this.modifyUri(result[i].uri);
        let modifiedResult = {
          ...result[i], // Copy other properties from the original object
          uri: modifiedUri, // Replace the 'uri' property with the modified URI
        };
        this.highlightsProducts.push(modifiedResult);
        // this.highlightsProducts.push(res.results[i]);
      }

      localStorage.removeItem('data');
      localStorage.setItem('data', JSON.stringify(this.highlightsProducts));
      const newData: any = JSON.parse(localStorage.getItem('data'));
      this.localStorageData = newData;
      this.noOfPages = res.pager.pages;
      this.resultsFound = res.pager.count;
      this.isShowViewMore();
    });
  }
  getSelectedCategories() {
    return this.specialInterestItems.filter((item: any) => item.selected).map((item: any) => item.value);
  }
  toggleSelection(item: any) {
    item.selected = !item.selected; // Toggle the selected state
    this.filterData(this.getSelectedCategories());
  }
  filterData(selectedSpecialInterest: any) {
    this.highlightsProducts = [];
    //this.sortValue = 'newest';
    //this.selectedSpecialFields(selectedSpecialInterest);
    this.selectedSpecialInterest = this.specialInterestItems
      .filter((item: any) => item.selected)
      .map((item: any) => item.value);
    if (this.sortValue === 'A to Z' || this.sortValue === 'Z to A') {
      this.getDataByAlphabet(this.pageNumber, this.selectedSpecialInterest);
      // this.highlightsProducts = [];
      // this.localStorageData =
      //   this.sortValue === 'A to Z'
      //     ? _.orderBy(this.localStorageData, [(obj) => obj.title.toLowerCase()], ['asc'])
      //     : _.orderBy(this.localStorageData, [(obj) => obj.title.toLowerCase()], ['desc']);
      // this.highlightsProducts = this.localStorageData;
    } else if (this.sortValue === 'popularity') {
      this.getPopularityData(this.pageNumber, this.selectedSpecialInterest);
    } else {
      this.selectedSpecialFields(this.selectedSpecialInterest, this.sortValue, this.pageNumber);
    }
  }
  selectedSpecialFields(selctedItems: any, sortValue?: any, pageNo?: any) {
    this.localStorageData = [];
    if (pageNo == 0) {
      this.highlightsProducts = [];
    }
    let itemCode: any = [];
    if (sortValue) {
      this.sortValue = sortValue;
    }
    if (selctedItems) {
      Array.from(selctedItems).map((data: any) => {
        itemCode.push(data);
      });
    } else {
      itemCode = '';
    }
    if (pageNo) {
      this.pageNumber = pageNo;
    } else {
      this.pageNumber = 0;
    }
    // this.pageNumber = 0;
    this.language = localStorage.getItem('language').toLocaleLowerCase();
    if (this.sortValue == 'oldest') {
      return this.productService.getHighlightSmallPaging(this.pageNumber, this.language, itemCode).then((res) => {
        let result = this.specialInterestFilter(res.results);
        for (var i = 0; i < result.length; i++) {
          let modifiedUri = this.modifyUri(result[i].uri);
          let modifiedResult = {
            ...result[i], // Copy other properties from the original object
            uri: modifiedUri, // Replace the 'uri' property with the modified URI
          };
          this.highlightsProducts.push(modifiedResult);
          // this.highlightsProducts.push(res.results[i]);
        }

        localStorage.removeItem('data');
        localStorage.setItem('data', JSON.stringify(this.highlightsProducts));
        const newData: any = JSON.parse(localStorage.getItem('data'));
        this.localStorageData = newData;
        this.noOfPages = res.pager.pages;
        this.resultsFound = res.pager.count;
        //this.highlightsProducts.push(res);
        this.isShowViewMore();
      });
    } else {
      return this.productService
        .getHighlightSmallPagingDescOrder(this.pageNumber, this.language, itemCode)
        .then((res) => {
          let result = this.specialInterestFilter(res.results);
          result.forEach((rData: any) => {
            let modifiedUri = this.modifyUri(rData.uri);
            let modifiedResult = {
              ...rData, // Copy other properties from the original object
              uri: modifiedUri, // Replace the 'uri' property with the modified URI
            };
            this.highlightsProducts.push(modifiedResult);
            // this.highlightsProducts.push(rData);
          });
          localStorage.removeItem('data');
          localStorage.setItem('data', JSON.stringify(this.highlightsProducts));
          const newData: any = JSON.parse(localStorage.getItem('data'));
          this.localStorageData = newData;
          this.noOfPages = res.pager.pages;
          this.resultsFound = res.pager.count;
          //this.highlightsProducts.push(res);
          this.isShowViewMore();
        });
    }
  }

  specialInterestFilter(highlightItems: any) {
    Array.from(highlightItems).map((data: any) => {
      //let [num, specialIntrest] = data.field_special_intrest.toLowerCase().split(':');
      data.title = data.title.replace('&#039;', "'");
      let specialIntrest =
        data.field_blog_category !== undefined ? data.field_blog_category.toLowerCase() : data.field_blog_category;
      specialIntrest = specialIntrest.replace(/&amp;/g, '&');
      switch (specialIntrest) {
        case 'things to do':
          data.specialInterestName = 'Things To Do';
          data.specialIntersetIcon = 'icon-icons8-scuba-mask-50';
          break;
        case 'focus':
          data.specialInterestName = 'Focus';
          data.specialIntersetIcon = 'icon-icons8-sail-boat-50';
          break;
        case 'sustainability':
          data.specialInterestName = 'Sustainability';
          data.specialIntersetIcon = 'icon-icons8-fishing-50';
          break;
        case 'travel tips':
          data.specialInterestName = 'Travel Tips';
          data.specialIntersetIcon = 'icon-icons8-home-office-50';
          break;
        case 'romance':
          data.specialInterestName = 'Romance';
          data.specialIntersetIcon = 'icon-icons8-romance-50';
          break;
        case 'nature & wildlife':
          data.specialInterestName = 'Nature & Wildlife';
          data.specialIntersetIcon = 'icon-icons8-leaf-50';
          break;
        case 'gastronomy':
          data.specialInterestName = 'Gastronomy';
          data.specialIntersetIcon = 'icon-gastronomy';
          break;
        case 'local made':
          data.specialInterestName = 'Local Made';
          data.specialIntersetIcon = 'icon-local-made';
          break;
        case 'culture & history':
          data.specialInterestName = 'Culture & History';
          data.specialIntersetIcon = 'icon-icons8-romance-50';
        // default:
        //   data.specialInterestName = this.sanitizer.bypassSecurityTrustResourceUrl('');
        //   break;
      }
    });
    return highlightItems;
  }

  loadData() {
    this.language = localStorage.getItem('language').toLocaleLowerCase();
    this.productService.getHighlightSmallPagingDescOrder(this.pageNumber, this.language, '').then((res) => {
      let result = this.specialInterestFilter(res.results);
      for (let index = 0; index < result.length; index++) {
        result[index] = {
          ...result[index],
          uri: this.modifyUri(result[index].uri),
        };
      }
      this.highlightsProducts = result;
      localStorage.setItem('data', JSON.stringify(this.highlightsProducts));
      const loadData: any = JSON.parse(localStorage.getItem('data'));
      this.localStorageData = loadData;
      this.noOfPages = res.pager.pages;
      this.resultsFound = res.pager.count;
      this.isShowViewMore();
    });
  }

  getHighlightUrl(item: any): string {
    var queryParams = this.productService.getBlogViewNode(item);
    return '/blog-details/' + item.nid + '/' + queryParams;
  }

  itemClick(item: any) {
    var queryParams = this.productService.getBlogViewNode(item);
    var url = '/blog-details/' + item.nid + '/' + queryParams;
    window.open(url, '_blank');
  }

  ViewMoreBlogs() {
    this.pageNumber = this.pageNumber + 1;
    const lastRecordElement = this.productsList.nativeElement.lastElementChild;
    const fixedHeaderHeight = 80;
    const nextScrollTop = lastRecordElement.offsetTop + lastRecordElement.offsetHeight - fixedHeaderHeight;
    if (this.sortValue === 'A to Z' || this.sortValue === 'Z to A') {
      this.getDataByAlphabet(this.pageNumber, this.selectedSpecialInterest).then(() => {
        document.documentElement.scrollTo({ top: nextScrollTop, left: 0, behavior: 'smooth' });
      });
    } else if (this.sortValue === 'popularity') {
      this.getPopularityData(this.pageNumber, this.selectedSpecialInterest).then(() => {
        document.documentElement.scrollTo({ top: nextScrollTop, left: 0, behavior: 'smooth' });
      });
    } else {
      this.selectedSpecialFields(this.selectedSpecialInterest, this.sortValue, this.pageNumber).then(() => {
        document.documentElement.scrollTo({ top: nextScrollTop, left: 0, behavior: 'smooth' });
      });
    }
    this.isShowViewMore();
  }
  isShowViewMore() {
    if (this.noOfPages) {
      let noOfpages = this.noOfPages - 1;
      if (this.pageNumber < noOfpages) this.isViewMoreRecords = true;
      else this.isViewMoreRecords = false;
    } else {
      this.isViewMoreRecords = false;
    }
  }
  sort(event: any) {
    if (event) {
      this.sortValue = event;
    }
    this.pageNumber = 0;
    //this.selectedSpecialInterest = [];
    if (this.sortValue === 'A to Z' || this.sortValue === 'Z to A') {
      this.getDataByAlphabet(this.pageNumber, this.selectedSpecialInterest);
      // this.highlightsProducts = [];
      // this.localStorageData =
      //   this.sortValue === 'A to Z'
      //     ? _.orderBy(this.localStorageData, [(obj) => obj.title.toLowerCase()], ['asc'])
      //     : _.orderBy(this.localStorageData, [(obj) => obj.title.toLowerCase()], ['desc']);
      // this.highlightsProducts = this.localStorageData;
    } else if (this.sortValue === 'popularity') {
      this.getPopularityData(this.pageNumber, this.selectedSpecialInterest);
    } else {
      this.selectedSpecialFields(this.selectedSpecialInterest, event, this.pageNumber);
    }
  }
  searchToggle() {
    const element = document.getElementById('SearchToggle');
    element.classList.toggle('expanded');
  }

  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }

  ngAfterViewChecked() {
    const input = document.querySelector('.p-autocomplete-input') as HTMLInputElement;

    if (!input) {
      return;
    }

    const controls = input.getAttribute('aria-controls');
    if (controls && !document.getElementById(controls)) {
      input.removeAttribute('aria-controls');
    }

    const active = input.getAttribute('aria-activedescendant');
    if (active && !document.getElementById(active)) {
      input.removeAttribute('aria-activedescendant');
    }
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-haspopup', 'listbox');
  }
}
